var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopic5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 34,
    viewBox: "0 0 60 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3927 34H17.6952C16.1139 34 14.681 33.0684 14.0393 31.6231L0 0L60 0L46.0524 31.6146C45.4127 33.0644 43.9774 34 42.3927 34Z",
    fill: "#AFF7CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9488 26.264C28.3488 26.264 26.9488 25.768 25.7488 24.776C24.5648 23.784 23.9408 22.544 23.8768 21.056H27.2848C27.4288 21.632 27.7408 22.104 28.2208 22.472C28.7168 22.84 29.2928 23.024 29.9488 23.024C30.7808 23.024 31.4288 22.776 31.8928 22.28C32.3728 21.768 32.6128 21.136 32.6128 20.384C32.6128 19.616 32.3648 18.984 31.8688 18.488C31.3888 17.992 30.7648 17.744 29.9968 17.744C29.3408 17.744 28.7808 17.904 28.3168 18.224C27.8528 18.544 27.5248 18.976 27.3328 19.52L24.4288 18.632L26.3488 8.96H34.6528V12.152H28.8928L28.2448 15.344C28.8528 14.96 29.6368 14.768 30.5968 14.768C32.1968 14.768 33.4768 15.312 34.4368 16.4C35.4128 17.488 35.9008 18.904 35.9008 20.648C35.9008 22.344 35.3488 23.704 34.2448 24.728C33.1568 25.752 31.7248 26.264 29.9488 26.264Z",
    fill: "#202D66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic5);
export default __webpack_public_path__ + "static/media/topic5.bfd453f5d023ba6d7a15a0e787448656.svg";
export { ForwardRef as ReactComponent };